import STRINGS from 'utils/strings'
import {
  coerceScheduleForStudyFlag,
  isMultiScheduleInstrumentUpload,
} from 'utils/studyConfigUtils'
import { cleanUploadedJSON } from './PropertyFields'

/**
 * Uploaded JSON is multi-schedule when schedule is an array with 2+ entries, or instrument_reuse is set.
 */
export const isUploadedMultiScheduleRejected = metadata => isMultiScheduleInstrumentUpload(metadata)

/**
 * Validate multi-schedule flag, clean cohorts, and set instrument_reuse before schedule payload prep.
 */
export const prepareUploadedInstrumentData = ({
  data,
  hasMultiSchedule,
  participants,
  user,
  studyId,
}) => {
  const working = { ...data, metadata: { ...(data.metadata || {}) } }

  if (!hasMultiSchedule && isUploadedMultiScheduleRejected(working.metadata)) {
    const error = new Error(STRINGS.multiScheduleUploadNotAllowed)
    error.isMultiScheduleUploadRejected = true
    throw error
  }

  let prepared = cleanUploadedJSON(working, participants, user, studyId)
  prepared.metadata = prepared.metadata || {}

  if (!hasMultiSchedule) {
    prepared.metadata.schedule = coerceScheduleForStudyFlag(prepared.metadata.schedule, false)
    prepared.metadata.instrument_reuse = false
  } else if (prepared.metadata.schedule) {
    const scheduleList = Array.isArray(prepared.metadata.schedule)
      ? prepared.metadata.schedule
      : [prepared.metadata.schedule]
    prepared.metadata.instrument_reuse =
      !!prepared.metadata.instrument_reuse || scheduleList.length > 1
  }

  return prepared
}
